// src/components/OnboardingAccessGate.jsx
// Keeps users out of the dashboard until they meet the onboarding minimum
// (verified email + phone, profile ≥ 70%, first gig/request). The server decides
// (GET /auth/onboarding-gate); this only routes. Admins always pass (server returns 'none').
import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { fetchAccessGate, routeForGateStep } from '../utils/accessGate';

const Checking = () => (
  <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f9fafb' }}>
    <div style={{ width: 40, height: 40, borderRadius: '50%', border: '3px solid #e5e7eb', borderTopColor: '#2563eb', animation: 'oag-spin 0.8s linear infinite' }} />
    <style>{'@keyframes oag-spin{to{transform:rotate(360deg)}}'}</style>
  </div>
);

const OnboardingAccessGate = ({ children }) => {
  const location = useLocation();
  const [state, setState] = useState({ status: 'checking', redirect: null });

  useEffect(() => {
    let cancelled = false;
    fetchAccessGate()
      .then((gate) => {
        if (cancelled) return;
        const redirect = routeForGateStep(gate.step);
        setState({ status: redirect ? 'redirect' : 'allowed', redirect });
      })
      .catch((err) => {
        if (cancelled) return;
        // 401s are handled by AuthContext (logout). For network/server errors we let the
        // user through rather than trapping them on a spinner; the gate re-runs on the next
        // navigation and on the next login.
        console.warn('[OnboardingAccessGate] gate check failed:', err?.response?.status || err?.message);
        setState({ status: 'allowed', redirect: null });
      });
    return () => { cancelled = true; };
  }, [location.pathname]);

  if (state.status === 'checking') return <Checking />;
  if (state.status === 'redirect') {
    return <Navigate to={state.redirect} replace state={{ autoSend: true, from: location.pathname }} />;
  }
  return children;
};

export default OnboardingAccessGate;
